export enum PropertyRelationship {
  interested = 'INTERESTED',
  investment = 'INVESTMENT',
  myHome = 'MY_HOME',
}

export const mapPropertyRelationshipToEnum = (
  relationship?: string,
): PropertyRelationship | undefined => {
  switch (relationship) {
    case 'INTERESTED':
      return PropertyRelationship.interested;
    case 'INVESTMENT':
      return PropertyRelationship.investment;
    case 'MY_HOME':
      return PropertyRelationship.myHome;
    default:
      return undefined;
  }
};
